import React from 'react'
import ConversationStarter from '#src/components/ConversationStarter'
import { withIdentity, WithIdentityProps } from '#src/containers/Identity'
import { ChatWidget, withChat, WithChatProps } from '@deal/chat-firebase'
import { ChatWidgetExpertFragment } from '#src/generated/graphql'
import { withRouter, RouteComponentProps } from 'react-router'

interface ChatHeadProps {
  onStartConversation: () => any
  businessUserId: string
  conversationId?: string | null
  className?: string
  collapsedClassName?: string
  expert: ChatWidgetExpertFragment
}

const ChatHeadContainer: React.SFC<
  WithIdentityProps & ChatHeadProps & WithChatProps & RouteComponentProps<{}>
> = ({
  myself,
  className,
  collapsedClassName,
  conversationId,
  firebaseChatClient,
  onStartConversation,
  expert,
  history
}) => {
  if (!myself || !firebaseChatClient) {
    return null
  }

  const expertIsOnline = expert.expertAttributes
    ? expert.expertAttributes.acceptingNewRequests
    : false

  return (
    <ChatWidget
      userId={expert.messagingUser.id}
      conversationId={conversationId || undefined}
      online={expertIsOnline}
      rating={'stars'}
      history={history}
      getAppRoot={() => document.querySelector('#deal')}
      collapsedClassName={collapsedClassName}
      className={className}
      onConversationStarted={() => {
        onStartConversation()
      }}
    >
      <ConversationStarter expert={expert} />
    </ChatWidget>
  )
}

export default withRouter(withIdentity(withChat(ChatHeadContainer)))
